import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "confirmModal",
  tabindex: "-1",
  "aria-labelledby": "confirmModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mt-4 mb-2 mb-lg-4" }
const _hoisted_8 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_9 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_10 = { class: "col-lg-12 break-word" }
const _hoisted_11 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mt-4 mb-2 mb-lg-4" }
const _hoisted_12 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_13 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_14 = { class: "col-lg-12 break-word" }
const _hoisted_15 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mt-4 mb-2 mb-lg-4" }
const _hoisted_16 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_17 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_18 = { class: "col-lg-12 break-word" }
const _hoisted_19 = { class: "row mx-5 px-lg-0 pb-2 pb-lg-4 gx-3 mb-3" }
const _hoisted_20 = { class: "w-max-content col-lg-3 fw-bold" }
const _hoisted_21 = { class: "row mx-0 px-0 col-lg-8" }
const _hoisted_22 = { class: "col-lg-12" }
const _hoisted_23 = { class: "break-word" }
const _hoisted_24 = { class: "text-center mb-4 fw-bold" }
const _hoisted_25 = { class: "d-flex justify-content-center modal-footer" }

import { translate } from '@/languages/i18n'
import { PropType, computed } from 'vue'
import Button from '@/components/button/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  formData: {
    type: Object,
    default: () => ({
      message_type: 0,
      name: '',
      title: '',
      content: '',
    }),
  },
  // resetForm: {
  //   type: Function as PropType<() => void | undefined>,
  // },
  onSubmitMessage: {
    type: Function as PropType<() => void | undefined>,
  },
  disabledButton: Boolean,
},
  setup(__props) {

const props = __props



const translateMessageType = computed(() => {
  switch (props.formData.message_type) {
    case 0:
      return translate('OE50sendAllMessages')
    case 1:
      return translate('sendInviteOnlyGroupInfo')
    default:
      return ''
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('createMessageTemplate')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('templateType')), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translateMessageType)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_unref(translate)('templateName')), 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(__props.formData.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(translate)('title')), 1),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, _toDisplayString(__props.formData.title), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(translate)('content')), 1),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("p", _hoisted_23, _toDisplayString(__props.formData.content), 1)
              ])
            ])
          ]),
          _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(translate)('ques')), 1),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(Button, {
              title: _unref(translate)('titleButtonEdit'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'me-2 fw-bold'
            }, null, 8, ["title"]),
            _createVNode(Button, {
              title: _unref(translate)('signUp'),
              type: 'secondary',
              onClick: __props.onSubmitMessage,
              className: 'fw-bold',
              disabled: __props.disabledButton
            }, null, 8, ["title", "onClick", "disabled"])
          ])
        ])
      ])
    ])
  ]))
}
}

})